import { onError } from '@apollo/client/link/error';

export const apolloErrorLink = onError(({ graphQLErrors, networkError, protocolErrors }) => {
  if (graphQLErrors)
    graphQLErrors.forEach((error) => {
      const { locations, message, path } = error;
      console.error(
        `[Apollo / GraphQL error]:`,
        `Message: ${message}`,
        `Location: ${JSON.stringify(locations)},`,
        `Path: ${path},`,
      );
    });

  if (protocolErrors) {
    protocolErrors.forEach(({ extensions, message }) => {
      console.error(`[Apollo / Protocol error]: Message: ${message}, Extensions: ${JSON.stringify(extensions)}`);
    });
  }

  if (networkError) {
    console.error(`[Apollo / Network error]: ${networkError}`);
  }
});
